import type { MindmapSyntaxNode, MindmapSyntaxTree } from './Ast';

const INDENT = '  ';

const formatLine = (node: MindmapSyntaxNode) => {
  const indent = INDENT.repeat(Math.max(0, node.depth));
  let line = `${indent}- ${node.title}`;

  if (node.link) {
    line = `${line} -> ${node.link}`;
  }

  if (node.tokens.length) {
    line = `${line} ||| ${node.tokens.join(' ')}`;
  }

  return line;
};

const collectLines = (node: MindmapSyntaxNode, acc: string[]) => {
  acc.push(formatLine(node));
  node.children.forEach((child) => collectLines(child, acc));
};

export function printMindmapSyntax(tree: MindmapSyntaxTree): string {
  if (!tree.root) return '';
  const lines: string[] = [];
  collectLines(tree.root, lines);
  return lines.length ? `${lines.join('\n')}\n` : '';
}
